import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './HRAdminPanel.css';
import Sidebar from './Sidebar.js';
import { FaSignOutAlt } from 'react-icons/fa';
// import axios from 'axios';
// import jsPDF from 'jspdf';
// import html2canvas from 'html2canvas';
// import { FaBars } from 'react-icons/fa';
import PunchingTimePage from './PunchingTimePage.js';
import TerminatedStaffPage from './TerminatedStaffPage.js';
import LeavePermissionPage from './LeaveRequestsPage.js';
import StaffAppoiments from './StaffAppoiments.js';
import StaffDetailsPage from './StaffDetailsPage.js';
import DailyAttendancePage from './DailyAttendancePage.js';
import { useAuth } from '../../../contexts/AuthContext';

const HRAdminPanel = () => {
  const { currentUser, userProfile } = useAuth();
  const [activeTab, setActiveTab] = useState('staff-details');
  const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth > 768);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!currentUser) {
          // Don't redirect immediately, wait for auth to load
          return;
        }

        // Wait for userProfile to load (it might be null initially on refresh)
        if (currentUser && !userProfile) {
          // User is authenticated but profile not loaded yet, wait
          return;
        }

        // Use userProfile from AuthContext instead of localStorage
        setUser(userProfile || {});
      } catch (err) {
        console.error(err.response?.data?.error || 'Failed to fetch data');
      }
    };

    fetchData();
  }, [currentUser, userProfile, navigate]);


  return (
    <div className="hr-admin-container">
      <Sidebar
        activeTab={activeTab}
        onTabChange={(tab) => {
          setActiveTab(tab);
          if (window.innerWidth <= 768) {
            setSidebarOpen(false);
          }
        }}
        onSignOut={async () => {
          try {
            // Record punch out before logout
            if (currentUser && userProfile?.email) {
              const idToken = await currentUser.getIdToken(true);
              await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/auth/punching-times/record-logout`, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': `Bearer ${idToken}`
                },
                body: JSON.stringify({ email: userProfile.email })
              });
            }
          } catch (error) {
            // Silently continue with logout even if punch out fails
            console.log('Punch out recording failed during logout, continuing...');
          }
          
          localStorage.clear();
          navigate('/login');
        }}
        isOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        sidebarOpen={sidebarOpen}
        user={user}
      />

      <div className={`hr-admin-panel ${!sidebarOpen ? 'shifted' : ''}`}>
        <div className="panel-header">
          <h2>HR Admin Panel</h2>
          <button 
            className="mobile-logout-btn"
            onClick={async () => {
              try {
                // Record punch out before logout (same as sidebar logout)
                if (currentUser && userProfile?.email) {
                  const idToken = await currentUser.getIdToken(true);
                  await fetch(`${process.env.REACT_APP_API_URL || 'http://localhost:5000'}/api/auth/punching-times/record-logout`, {
                    method: 'POST',
                    headers: {
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${idToken}`
                    },
                    body: JSON.stringify({ email: userProfile.email })
                  });
                }
              } catch (error) {
                // Silently continue with logout even if punch out fails
                console.log('Punch out recording failed during logout, continuing...');
              }
              
              localStorage.clear();
              navigate('/login');
            }}
            title="Sign Out"
          >
            <FaSignOutAlt /> Sign Out
          </button>
        </div>

        <div className="tabs">
          {['staff-details', 'appointments', 'punching-time', 'daily-attendance', 'terminated-staff', 'leave-permission'].map(tab => (
            <button
              key={tab}
              className={activeTab === tab ? 'active-tab' : 'tab'}
              onClick={() => setActiveTab(tab)}
            >
              {tab.replace('-', ' ').replace(/\b\w/g, c => c.toUpperCase())}
            </button>
          ))}
        </div>

        <div className="tab-content">
          {activeTab === 'appointments' && <StaffAppoiments />}
          {activeTab === 'staff-details' && <StaffDetailsPage />}
          {activeTab === 'punching-time' && <PunchingTimePage />}
          {activeTab === 'daily-attendance' && <DailyAttendancePage />}
          {activeTab === 'terminated-staff' && <TerminatedStaffPage />}
          {activeTab === 'leave-permission' && <LeavePermissionPage />}
        </div>
      </div>
    </div>
  );
};

export default HRAdminPanel;